const ToggleList = (function(window, $) {

    function ToggleList(target) {
        this.element = $(target);
        this.button = this.element.find('.btn-toggle');

        this.addEvents();
    }

    ToggleList.prototype.addEvents = function() {
        this.button.on('click', this.showAll.bind(this));
    };

    ToggleList.prototype.showAll = function(e) {
        e.preventDefault();

        let items = $(e.currentTarget).closest(this.element).find('.ui-grid-item.is-hidden'); 

        $(e.currentTarget).addClass('is-hidden');
        $(items).removeClass('is-hidden');
    };

    return ToggleList;

}(window, jQuery));

export {ToggleList};
